import { render, staticRenderFns } from "./ProductBaseInfo.vue?vue&type=template&id=1848b07e&scoped=true&"
import script from "./ProductBaseInfo.vue?vue&type=script&lang=js&"
export * from "./ProductBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductBaseInfo.vue?vue&type=style&index=0&id=1848b07e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1848b07e",
  null
  
)

export default component.exports